export default __webpack_public_path__ + "static/media/dragndrop.9cdd1e3d.png";